var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{attrs:{"height":"100%","width":"100%"}},[_c('v-card-title',[_c('v-col',{attrs:{"cols":"12","sm":"2"}},[_vm._v(_vm._s(_vm.$t('ContentCreator.ContentCreator')))]),_c('v-col',{staticClass:"right text-right",attrs:{"cols":"12","sm":"3"}})],1),_c('div',{attrs:{"id":"gjs"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }